export default __webpack_public_path__ + "static/press-awards-janesville-6290e268fb98b1a21b157aa969a322ab.png";